import React from 'react'
import {useIntl} from 'react-intl'

import {MenuItem} from '../config/menuConfig'

interface SuggestionBubblesProps {
  options: MenuItem[]
  onOptionClick: (item: MenuItem) => void
  loading?: boolean
  selectedId?: string
}

const SuggestionBubbles: React.FC<SuggestionBubblesProps> = ({
  options,
  onOptionClick,
  loading,
  selectedId,
}) => {
  const intl = useIntl()

  return (
    <div
      role='list'
      aria-label='Suggestion options'
      style={{
        display: 'flex',
        gap: 8,
        overflowX: 'auto',
        overflowY: 'hidden',
        padding: '2px 4px 8px',
        scrollbarWidth: 'thin',
      }}
    >
      {options.map((option) => {
        const isSelected = selectedId === option.id
        return (
          <button
            key={option.id}
            type='button'
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onOptionClick(option)
            }}
            disabled={!!loading}
            title={
              option.descriptionId
                ? intl.formatMessage({
                    id: option.descriptionId,
                  })
                : option.description
            }
            role='listitem'
            aria-pressed={isSelected ? 'true' : 'false'}
            style={{
              flex: '0 0 auto',
              padding: '8px 16px',
              borderRadius: 20,
              border: isSelected
                ? '2px solid var(--bs-primary, #0d6efd)'
                : '1px solid var(--bs-primary, #0d6efd)',
              backgroundColor: isSelected ? 'var(--bs-primary, #0d6efd)' : 'transparent',
              color: isSelected ? 'white' : 'var(--bs-primary, #0d6efd)',
              fontSize: '0.9rem',
              fontWeight: 500,
              cursor: loading ? 'not-allowed' : 'pointer',
              whiteSpace: 'nowrap',
              transition: 'all 0.15s ease',
              opacity: loading ? 0.6 : 1,
              boxShadow: isSelected ? 'var(--bs-shadow-sm, none)' : 'none',
            }}
            onMouseEnter={(e) => {
              if (!loading && !isSelected) {
                e.currentTarget.style.backgroundColor = 'var(--bs-primary, #0d6efd)'
                e.currentTarget.style.color = 'white'
              }
            }}
            onMouseLeave={(e) => {
              if (!isSelected) {
                e.currentTarget.style.backgroundColor = 'transparent'
                e.currentTarget.style.color = 'var(--bs-primary, #0d6efd)'
              }
            }}
          >
            {option.labelId
              ? intl.formatMessage({
                  id: option.labelId,
                })
              : option.label}
          </button>
        )
      })}
    </div>
  )
}

export default SuggestionBubbles
